var _defineProperty = require("/builds/coredigitalmedia/engineering/seo/lmb-static/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/builds/coredigitalmedia/engineering/seo/lmb-static/node_modules/@babel/runtime/helpers/slicedToArray.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(function () {
    try {
      return require("gatsby");
    } catch (e) {}
  }(), function () {
    try {
      return require("gatsby-plugin-image");
    } catch (e) {}
  }()) : "function" == typeof define && define.amd ? define(["gatsby", "gatsby-plugin-image"], t) : "object" == typeof exports ? exports.default = t(function () {
    try {
      return require("gatsby");
    } catch (e) {}
  }(), function () {
    try {
      return require("gatsby-plugin-image");
    } catch (e) {}
  }()) : e.default = t(e.gatsby, e["gatsby-plugin-image"]);
}(this, function (e, t) {
  return function () {
    var a = {
      892: function _(e, t, a) {
        "use strict";

        a.d(t, {
          default: function _default() {
            return k;
          }
        });
        var r = a(689),
            n = a.n(r),
            i = a(580),
            o = a.n(i),
            s = "cdmLibrary-ccl-seo-BlockButton-module--buttonIconImg",
            l = a(379),
            c = a.n(l),
            u = a(795),
            d = a.n(u),
            p = a(569),
            g = a.n(p),
            m = a(565),
            f = a.n(m),
            b = a(216),
            v = a.n(b),
            y = a(589),
            h = a.n(y),
            C = a(71),
            L = {};
        L.styleTagTransform = h(), L.setAttributes = f(), L.insert = g().bind(null, "head"), L.domAPI = d(), L.insertStyleElement = v(), c()(C.Z, L), C.Z && C.Z.locals && C.Z.locals;

        var P = function P(e) {
          var t = e.label,
              a = e.disabled,
              r = e.submit,
              i = e.onClick,
              o = e.icon;
          return n().createElement("button", {
            className: "".concat("cdmLibrary-ccl-seo-BlockButton-module--mortgageBlockButton", " ").concat(C.j),
            type: r ? "submit" : "button",
            onClick: function onClick() {
              return !r && i();
            },
            "data-test": "block_button",
            "data-testid": "mortgage_block_button",
            disabled: a
          }, function (e) {
            return e ? "string" == typeof e ? n().createElement("span", {
              className: s
            }, n().createElement("img", {
              alt: "icon",
              src: e
            })) : n().createElement("span", {
              className: s
            }, e) : null;
          }(o), n().createElement("span", null, t));
        };

        P.propTypes = {
          label: o().oneOfType([o().string]),
          disabled: o().bool,
          submit: o().bool.isRequired,
          onClick: o().oneOfType([o().func, o().bool]),
          icon: o().oneOfType([o().string, o().element, o().func, o().oneOf([null])])
        }, P.defaultProps = {
          label: "Continue",
          disabled: !1,
          onClick: !1,
          icon: null
        };
        var k = P;
      },
      947: function _(e, t, a) {
        "use strict";

        a.d(t, {
          default: function _default() {
            return j;
          }
        });
        var r = a(689),
            n = a.n(r),
            i = a(580),
            o = a.n(i),
            s = a(985),
            l = "cdmLibrary-ccl-seo-GridCard-module--wpPostImage",
            c = a(379),
            u = a.n(c),
            d = a(795),
            p = a.n(d),
            g = a(569),
            m = a.n(g),
            f = a(565),
            b = a.n(f),
            v = a(216),
            y = a.n(v),
            h = a(589),
            C = a.n(h),
            L = a(182),
            P = {};
        P.styleTagTransform = C(), P.setAttributes = b(), P.insert = m().bind(null, "head"), P.domAPI = p(), P.insertStyleElement = y(), u()(L.ZP, P), L.ZP && L.ZP.locals && L.ZP.locals;

        var k = "post_grid_card",
            x = "card_thumbnail",
            N = "card_title",
            E = "card_author",
            T = a(549),
            O = a(153),
            I = function I(e) {
          var t,
              a = e.featuredImage,
              r = e.title,
              i = e.author,
              o = e.pinned,
              c = e.minutes,
              u = e.link,
              d = e.titleTag,
              p = null;
          return p = a ? "gatsby" === s._which ? n().createElement(s.Image, {
            image: (0, s.getImage)(null === (t = a.node) || void 0 === t ? void 0 : t.localFile),
            className: "".concat(l, " ").concat(L.oD),
            alt: r,
            itemProp: "image",
            "data-testid": x,
            "data-test": x
          }) : n().createElement("picture", null, n().createElement("source", {
            srcSet: a.srcSet,
            sizes: a.sizes
          }), n().createElement("img", {
            itemProp: "image",
            "data-testid": x,
            "data-test": x,
            width: "681",
            height: "528",
            "data-main-image": !0,
            decoding: "async",
            loading: "lazy",
            src: a.src,
            srcSet: a.srcSet,
            alt: r
          })) : n().createElement("img", {
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2ODAuNzY0IiBoZWlnaHQ9IjUyOC4zNTQiIHZpZXdCb3g9IjAgMCAxODAuMTE5IDEzOS43OTQiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMy41OSAtNjYuNjM5KSIgcGFpbnQtb3JkZXI9ImZpbGwgbWFya2VycyBzdHJva2UiPjxwYXRoIGZpbGw9IiNkMGQwZDAiIGQ9Ik0xMy41OTEgNjYuNjM5SDE5My43MXYxMzkuNzk0SDEzLjU5MXoiLz48cGF0aCBkPSJtMTE4LjUwNyAxMzMuNTE0LTM0LjI0OSAzNC4yNDktMTUuOTY4LTE1Ljk2OC00MS45MzggNDEuOTM3SDE3OC43MjZ6IiBvcGFjaXR5PSIuNjc1IiBmaWxsPSIjZmZmIi8+PGNpcmNsZSBjeD0iNTguMjE3IiBjeT0iMTA4LjU1NSIgcj0iMTEuNzczIiBvcGFjaXR5PSIuNjc1IiBmaWxsPSIjZmZmIi8+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTI2LjExMSA3Ny42MzRoMTUyLjYxNHYxMTYuMDk5SDI2LjExMXoiLz48L2c+PC9zdmc+",
            className: l,
            alt: r,
            itemProp: "image",
            "data-testid": x,
            "data-test": x
          }), n().createElement("div", {
            className: "".concat("cdmLibrary-ccl-seo-GridCard-module--container", " ").concat(L.nC, " ").concat(o ? "pinned-post" : ""),
            itemScope: !0,
            "data-test": k,
            "data-testid": k,
            itemType: "https://schema.org/Article"
          }, n().createElement(O.default, {
            href: u,
            className: "".concat("cdmLibrary-ccl-seo-GridCard-module--imageContainer", " ").concat(L.Bj)
          }, p), n().createElement("div", {
            className: "cdmLibrary-ccl-seo-GridCard-module--cardContent"
          }, n().createElement(d, {
            itemProp: "headline",
            "data-testid": N,
            "data-test": N
          }, n().createElement(O.default, {
            href: u
          }, r)), n().createElement("div", null, i && n().createElement("span", {
            itemProp: "author",
            "data-test": E,
            "data-testid": E
          }, i), n().createElement(T.default, {
            minutes: c,
            verticalBar: !!i
          }))));
        };

        I.propTypes = {
          featuredImage: o().objectOf(o().object),
          author: o().string,
          title: o().string.isRequired,
          link: o().string.isRequired,
          pinned: o().bool,
          minutes: o().oneOfType([o().number, o().string]),
          titleTag: o().string
        }, I.defaultProps = {
          featuredImage: null,
          pinned: !1,
          minutes: 0,
          author: "",
          titleTag: "h3"
        };
        var j = I;
      },
      153: function _(e, t, a) {
        "use strict";

        a.d(t, {
          default: function _default() {
            return u;
          }
        });
        var r = a(689),
            n = a.n(r),
            i = a(580),
            o = a.n(i),
            s = a(825);
        var l = ["href", "children", "relative", "isLocal"];

        var c = function c(e) {
          var t,
              a = e.href,
              r = e.children,
              i = e.relative,
              o = e.isLocal,
              c = function (e, t) {
            if (null == e) return {};

            var a,
                r,
                n = function (e, t) {
              if (null == e) return {};
              var a,
                  r,
                  n = {},
                  i = Object.keys(e);

              for (r = 0; r < i.length; r++) {
                a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
              }

              return n;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (r = 0; r < i.length; r++) {
                a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
              }
            }

            return n;
          }(e, l),
              u = "a";

          return function (e) {
            return !e.target || !e.target.length;
          }(c) ? o && void 0 !== s._which && (u = s.Link) : function (e) {
            var t,
                a,
                r,
                n = [];
            null !== (t = e.rel) && void 0 !== t && t.includes("noopener") || n.push("noopener"), null !== (a = e.rel) && void 0 !== a && a.includes("noreferrer") || n.push("noreferrer"), null !== (r = e.rel) && void 0 !== r && r.length && n.push(e.rel), e.rel = n.join(" ");
          }(c), "a" === u ? (c["data-test"] = "component_linker_anchor", c["data-testid"] = "component_link2_anchor", c.href = a) : (c["data-test"] = "component_linker_link", c["data-testid"] = "component_link2_link", c.to = i ? "http" === (t = a).substring(0, 4).toLowerCase() || "//" === t.substring(0, 2) ? function (e) {
            return new URL(e, "http://".concat("xx.xx"));
          }(t).pathname : t : a), n().createElement(u, c, r);
        };

        c.propTypes = {
          href: o().string,
          isLocal: o().bool,
          relative: o().bool,
          children: o().node
        }, c.defaultProps = {
          href: "",
          relative: !0,
          isLocal: !0,
          children: !1
        };
        var u = c;
      },
      327: function _(e, t, a) {
        "use strict";

        a.d(t, {
          default: function _default() {
            return N;
          }
        });
        var r = a(689),
            n = a.n(r),
            i = a(580),
            o = a.n(i),
            s = a(678),
            l = a.n(s),
            c = "paginate_nav",
            u = a(379),
            d = a.n(u),
            p = a(795),
            g = a.n(p),
            m = a(569),
            f = a.n(m),
            b = a(565),
            v = a.n(b),
            y = a(216),
            h = a.n(y),
            C = a(589),
            L = a.n(C),
            P = a(408),
            k = {};
        k.styleTagTransform = L(), k.setAttributes = v(), k.insert = f().bind(null, "head"), k.domAPI = g(), k.insertStyleElement = h(), d()(P.Z, k), P.Z && P.Z.locals && P.Z.locals;

        var x = function x(e) {
          var t = e.breakLabel,
              a = e.pageCount,
              r = e.handleClick,
              i = e.containerClassName,
              o = e.pageRangeDisplayed,
              s = e.marginPagesDisplayed,
              c = e.nextLabel,
              u = e.previousLabel,
              d = e.defaultPage;
          return n().createElement("div", {
            "data-testid": "paginate_container",
            className: "".concat(P.r, " ").concat("cdmLibrary-ccl-seo-Paginate-module--paginationComponent")
          }, n().createElement(l(), {
            breakLabel: t,
            pageCount: a,
            pageRangeDisplayed: o,
            marginPagesDisplayed: s,
            containerClassName: i,
            onPageChange: r,
            previousLabel: u,
            nextLabel: c,
            forcePage: d
          }));
        };

        x.propTypes = {
          pageCount: o().number.isRequired,
          breakLabel: o().string,
          handleClick: o().func.isRequired,
          containerClassName: o().string,
          pageRangeDisplayed: o().number,
          marginPagesDisplayed: o().number,
          nextLabel: o().element,
          previousLabel: o().element,
          defaultPage: o().number
        }, x.defaultProps = {
          breakLabel: "...",
          containerClassName: "paginationContainer",
          pageRangeDisplayed: 5,
          marginPagesDisplayed: 1,
          nextLabel: n().createElement("span", {
            className: "".concat(c, " ").concat("paginate_nav_right")
          }, "»"),
          previousLabel: n().createElement("span", {
            className: "".concat(c, " ").concat("paginate_nav_left")
          }, "«"),
          defaultPage: 0
        };
        var N = x;
      },
      549: function _(e, t, a) {
        "use strict";

        a.d(t, {
          default: function _default() {
            return c;
          }
        });

        var r = a(689),
            n = a.n(r),
            i = a(580),
            o = a.n(i),
            s = "reading_time_element",
            l = function l(e) {
          var t = e.minutes,
              a = e.label,
              r = e.verticalBar,
              i = "string" == typeof t ? parseFloat(t) : t;
          Number.isNaN(i) && (i = 0);
          var o = (i = Math.round(i)) > 1 ? i.toString() : "< 1";
          return n().createElement("span", {
            className: "".concat(r ? "cdmLibrary-ccl-seo-ReadingTime-module--readtime" : "cdmLibrary-ccl-seo-ReadingTime-module--simpleReadtime"),
            "data-test": s,
            "data-testid": s
          }, o, " ", a);
        };

        l.propTypes = {
          minutes: o().oneOfType([o().number, o().string]).isRequired,
          label: o().string,
          verticalBar: o().bool
        }, l.defaultProps = {
          label: "min read",
          verticalBar: !0
        };
        var c = l;
      },
      78: function _(e, t, a) {
        "use strict";

        a.d(t, {
          default: function _default() {
            return v;
          }
        });
        var r = {};
        a.r(r), a.d(r, {
          gridBase: function gridBase() {
            return l;
          },
          gridCount4: function gridCount4() {
            return c;
          },
          gridCount5: function gridCount5() {
            return u;
          },
          gridCount6: function gridCount6() {
            return d;
          },
          gridElement: function gridElement() {
            return p;
          },
          gridTumbleIn: function gridTumbleIn() {
            return g;
          }
        });

        var n = a(689),
            i = a.n(n),
            o = a(580),
            s = a.n(o),
            l = "cdmLibrary-ccl-seo-PostGrid-module--gridBase",
            c = "cdmLibrary-ccl-seo-PostGrid-module--gridCount4",
            u = "cdmLibrary-ccl-seo-PostGrid-module--gridCount5",
            d = "cdmLibrary-ccl-seo-PostGrid-module--gridCount6",
            p = "cdmLibrary-ccl-seo-PostGrid-module--gridElement",
            g = "cdmLibrary-ccl-seo-PostGrid-module--gridTumbleIn",
            m = "post_grid",
            f = a(947),
            b = function b(e) {
          var t = e.posts,
              a = e.postLimit,
              n = e.titleTag;
          return i().createElement("ul", {
            className: "".concat(l, " ").concat(r["gridCount".concat(a)]),
            "data-test": m,
            "data-testid": m
          }, function (e, t, a) {
            return null == e ? void 0 : e.slice(0, t).map(function (e) {
              return i().createElement("li", {
                className: p,
                key: "grid-cell-".concat(e.databaseId)
              }, i().createElement(f.default, {
                title: e.title,
                minutes: e.readingtime,
                link: e.link,
                author: e.author,
                pinned: e.pinned || !1,
                featuredImage: e.featuredImage,
                titleTag: a
              }));
            });
          }(t, a, n));
        };

        b.propTypes = {
          postLimit: s().number.isRequired,
          posts: s().arrayOf(s().object).isRequired,
          titleTag: s().string
        }, b.defaultProps = {
          titleTag: "h3"
        };
        var v = b;
      },
      681: function _(e, t, a) {
        "use strict";

        a.d(t, {
          Z: function Z() {
            return r.default;
          }
        });
        var r = a(78);
      },
      352: function _(e, t, a) {
        "use strict";

        a.d(t, {
          default: function _default() {
            return p;
          }
        });

        var r = a(689),
            n = a.n(r),
            i = a(580),
            o = a.n(i),
            s = a(681),
            l = a(892),
            c = a(521),
            u = a(779),
            d = function d(e) {
          var t = e.queryArgs,
              a = e.gridLimit,
              i = e.btnLabel,
              o = e.titleTag,
              d = t.posts,
              p = t.total_found,
              _ref = (0, r.useState)(!0),
              _ref2 = _slicedToArray(_ref, 2),
              g = _ref2[0],
              m = _ref2[1],
              _ref3 = (0, r.useState)(d.slice(0, a)),
              _ref4 = _slicedToArray(_ref3, 2),
              f = _ref4[0],
              b = _ref4[1],
              _ref5 = (0, r.useState)(a),
              _ref6 = _slicedToArray(_ref5, 2),
              v = _ref6[0],
              y = _ref6[1],
              h = (0, r.useMemo)(function () {
            for (var e = [], t = Number(a), r = 0; r < f.length; r += t) {
              e.push(n().createElement(s.Z, {
                key: "post-grid-starting-".concat(r),
                posts: f.slice(r, r + t),
                postLimit: a,
                titleTag: o
              }));
            }

            return e;
          }, [f]);

          return n().createElement(n().Fragment, null, h, n().createElement("div", {
            className: u.iF
          }, g && p > a && n().createElement(l.default, {
            label: i,
            onClick: function onClick() {
              var e = v + a,
                  t = e < p - 1,
                  r = f.concat(d.slice(v, e));
              y(e), b(r), m(t);
            },
            buttonTestAttribute: c.I.BLOCK_BUTTON,
            submit: !1
          })));
        };

        d.propTypes = {
          queryArgs: o().oneOfType([o().object]),
          gridLimit: o().number,
          btnLabel: o().string,
          titleTag: o().string
        }, d.defaultProps = {
          queryArgs: {},
          gridLimit: 12,
          btnLabel: "See More",
          titleTag: c.defaultAttributes.titleTag
        };
        var p = d;
      },
      427: function _(e, t, a) {
        "use strict";

        a.d(t, {
          default: function _default() {
            return p;
          }
        });

        var r = a(689),
            n = a.n(r),
            i = a(580),
            o = a.n(i),
            s = a(681),
            l = a(327),
            c = a(521),
            u = a(779),
            d = function d(e) {
          var t = e.queryArgs,
              a = e.gridLimit,
              r = e.titleTag,
              i = e.handlePageChange,
              o = t.posts,
              c = t.total_found,
              d = null != e && e.currentPage ? e.currentPage - 1 : 0,
              p = d * a,
              g = o.slice(p, p + a);
          return n().createElement(n().Fragment, null, n().createElement(s.Z, {
            posts: g,
            postLimit: a,
            titleTag: r
          }), c > a && n().createElement("div", {
            className: u.li
          }, n().createElement(l.default, {
            breakLabel: e.breakLabel,
            pageCount: Math.ceil(c / a),
            handleClick: i,
            defaultPage: d,
            nextLabel: e.nextLabel,
            previousLabel: e.previousLabel
          })));
        };

        d.propTypes = {
          queryArgs: o().oneOfType([o().object]),
          gridLimit: o().number,
          currentPage: o().number,
          titleTag: o().string,
          handlePageChange: o().func.isRequired,
          breakLabel: o().string,
          nextLabel: o().element,
          previousLabel: o().element
        }, d.defaultProps = {
          queryArgs: {},
          gridLimit: 12,
          currentPage: 0,
          titleTag: c.defaultAttributes.titleTag,
          breakLabel: "...",
          nextLabel: void 0,
          previousLabel: void 0
        };
        var p = d;
      },
      521: function _(e, t, a) {
        "use strict";

        a.d(t, {
          I: function I() {
            return r;
          },
          defaultAttributes: function defaultAttributes() {
            return n;
          }
        });
        var r = {
          GRID_POST_CONTAINER: "grid_post_container"
        },
            n = {
          titleTag: "h3",
          containerId: "related-posts-grid"
        };
      },
      71: function _(e, t, a) {
        "use strict";

        a.d(t, {
          Z: function Z() {
            return l;
          },
          j: function j() {
            return s;
          }
        });
        var r = a(81),
            n = a.n(r),
            i = a(645),
            o = a.n(i)()(n());
        o.push([e.id, ".cdmLibrary-ccl-seo-BlockButton-core-module--mortgageBlockButton{cursor:pointer}.cdmLibrary-ccl-seo-BlockButton-core-module--mortgageBlockButton[disabled]{pointer-events:none}", ""]);
        var s = "cdmLibrary-ccl-seo-BlockButton-core-module--mortgageBlockButton";
        var l = o;
      },
      182: function _(e, t, a) {
        "use strict";

        a.d(t, {
          Bj: function Bj() {
            return l;
          },
          ZP: function ZP() {
            return u;
          },
          nC: function nC() {
            return s;
          },
          oD: function oD() {
            return c;
          }
        });
        var r = a(81),
            n = a.n(r),
            i = a(645),
            o = a.n(i)()(n());
        o.push([e.id, ".cdmLibrary-ccl-seo-GridCard-core-module--container{position:relative;overflow:hidden}.cdmLibrary-ccl-seo-GridCard-core-module--container .cdmLibrary-ccl-seo-GridCard-core-module--imageContainer{display:block;overflow:hidden}.cdmLibrary-ccl-seo-GridCard-core-module--container .cdmLibrary-ccl-seo-GridCard-core-module--imageContainer .cdmLibrary-ccl-seo-GridCard-core-module--wpPostImage{display:block;width:100%;object-fit:cover}", ""]);
        var s = "cdmLibrary-ccl-seo-GridCard-core-module--container",
            l = "cdmLibrary-ccl-seo-GridCard-core-module--imageContainer",
            c = "cdmLibrary-ccl-seo-GridCard-core-module--wpPostImage";
        var u = o;
      },
      408: function _(e, t, a) {
        "use strict";

        a.d(t, {
          Z: function Z() {
            return l;
          },
          r: function r() {
            return s;
          }
        });
        var r = a(81),
            n = a.n(r),
            i = a(645),
            o = a.n(i)()(n());
        o.push([e.id, ".cdmLibrary-ccl-seo-Paginate-core-module--paginationComponent .paginationContainer{padding-left:0;list-style:none;width:100%;text-align:center}.cdmLibrary-ccl-seo-Paginate-core-module--paginationComponent .paginationContainer li{display:inline-block;padding-left:0;text-align:center}", ""]);
        var s = "cdmLibrary-ccl-seo-Paginate-core-module--paginationComponent";
        var l = o;
      },
      645: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var a = "",
                  r = void 0 !== t[5];
              return t[4] && (a += "@supports (".concat(t[4], ") {")), t[2] && (a += "@media ".concat(t[2], " {")), r && (a += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), a += e(t), r && (a += "}"), t[2] && (a += "}"), t[4] && (a += "}"), a;
            }).join("");
          }, t.i = function (e, a, r, n, i) {
            "string" == typeof e && (e = [[null, e, void 0]]);
            var o = {};
            if (r) for (var s = 0; s < this.length; s++) {
              var l = this[s][0];
              null != l && (o[l] = !0);
            }

            for (var c = 0; c < e.length; c++) {
              var u = [].concat(e[c]);
              r && o[u[0]] || (void 0 !== i && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = i), a && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = a) : u[2] = a), n && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = n) : u[4] = "".concat(n)), t.push(u));
            }
          }, t;
        };
      },
      81: function _(e) {
        "use strict";

        e.exports = function (e) {
          return e[1];
        };
      },
      779: function _(e, t, a) {
        "use strict";

        a.d(t, {
          iF: function iF() {
            return n;
          },
          li: function li() {
            return i;
          },
          xv: function xv() {
            return r;
          }
        });
        var r = "cdmLibrary-ccl-seo-GridContainer-module--gridPostContainer",
            n = "cdmLibrary-ccl-seo-GridContainer-module--paginateButtonContainer",
            i = "cdmLibrary-ccl-seo-GridContainer-module--paginateNumberContainer";
      },
      379: function _(e) {
        "use strict";

        var t = [];

        function a(e) {
          for (var a = -1, r = 0; r < t.length; r++) {
            if (t[r].identifier === e) {
              a = r;
              break;
            }
          }

          return a;
        }

        function r(e, r) {
          for (var i = {}, o = [], s = 0; s < e.length; s++) {
            var l = e[s],
                c = r.base ? l[0] + r.base : l[0],
                u = i[c] || 0,
                d = "".concat(c, " ").concat(u);
            i[c] = u + 1;
            var p = a(d),
                g = {
              css: l[1],
              media: l[2],
              sourceMap: l[3],
              supports: l[4],
              layer: l[5]
            };
            if (-1 !== p) t[p].references++, t[p].updater(g);else {
              var m = n(g, r);
              r.byIndex = s, t.splice(s, 0, {
                identifier: d,
                updater: m,
                references: 1
              });
            }
            o.push(d);
          }

          return o;
        }

        function n(e, t) {
          var a = t.domAPI(t);
          return a.update(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
              a.update(e = t);
            } else a.remove();
          };
        }

        e.exports = function (e, n) {
          var i = r(e = e || [], n = n || {});
          return function (e) {
            e = e || [];

            for (var o = 0; o < i.length; o++) {
              var s = a(i[o]);
              t[s].references--;
            }

            for (var l = r(e, n), c = 0; c < i.length; c++) {
              var u = a(i[c]);
              0 === t[u].references && (t[u].updater(), t.splice(u, 1));
            }

            i = l;
          };
        };
      },
      569: function _(e) {
        "use strict";

        var t = {};

        e.exports = function (e, a) {
          var r = function (e) {
            if (void 0 === t[e]) {
              var a = document.querySelector(e);
              if (window.HTMLIFrameElement && a instanceof window.HTMLIFrameElement) try {
                a = a.contentDocument.head;
              } catch (e) {
                a = null;
              }
              t[e] = a;
            }

            return t[e];
          }(e);

          if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          r.appendChild(a);
        };
      },
      216: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = document.createElement("style");
          return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
        };
      },
      565: function _(e, t, a) {
        "use strict";

        e.exports = function (e) {
          var t = a.nc;
          t && e.setAttribute("nonce", t);
        };
      },
      795: function _(e) {
        "use strict";

        e.exports = function (e) {
          if ("undefined" == typeof document) return {
            update: function update() {},
            remove: function remove() {}
          };
          var t = e.insertStyleElement(e);
          return {
            update: function update(a) {
              !function (e, t, a) {
                var r = "";
                a.supports && (r += "@supports (".concat(a.supports, ") {")), a.media && (r += "@media ".concat(a.media, " {"));
                var n = void 0 !== a.layer;
                n && (r += "@layer".concat(a.layer.length > 0 ? " ".concat(a.layer) : "", " {")), r += a.css, n && (r += "}"), a.media && (r += "}"), a.supports && (r += "}");
                var i = a.sourceMap;
                i && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleTagTransform(r, e, t.options);
              }(t, e, a);
            },
            remove: function remove() {
              !function (e) {
                if (null === e.parentNode) return !1;
                e.parentNode.removeChild(e);
              }(t);
            }
          };
        };
      },
      589: function _(e) {
        "use strict";

        e.exports = function (e, t) {
          if (t.styleSheet) t.styleSheet.cssText = e;else {
            for (; t.firstChild;) {
              t.removeChild(t.firstChild);
            }

            t.appendChild(document.createTextNode(e));
          }
        };
      },
      678: function _(e, t, a) {
        var r;
        r = function r(e) {
          return function () {
            var t = {
              703: function _(e, t, a) {
                "use strict";

                var r = a(414);

                function n() {}

                function i() {}

                i.resetWarningCache = n, e.exports = function () {
                  function e(e, t, a, n, i, o) {
                    if (o !== r) {
                      var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                      throw s.name = "Invariant Violation", s;
                    }
                  }

                  function t() {
                    return e;
                  }

                  e.isRequired = e;
                  var a = {
                    array: e,
                    bigint: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: i,
                    resetWarningCache: n
                  };
                  return a.PropTypes = a, a;
                };
              },
              697: function _(e, t, a) {
                e.exports = a(703)();
              },
              414: function _(e) {
                "use strict";

                e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
              },
              98: function _(t) {
                "use strict";

                t.exports = e;
              }
            },
                a = {};

            function r(e) {
              var n = a[e];
              if (void 0 !== n) return n.exports;
              var i = a[e] = {
                exports: {}
              };
              return t[e](i, i.exports, r), i.exports;
            }

            r.n = function (e) {
              var t = e && e.__esModule ? function () {
                return e.default;
              } : function () {
                return e;
              };
              return r.d(t, {
                a: t
              }), t;
            }, r.d = function (e, t) {
              for (var a in t) {
                r.o(t, a) && !r.o(e, a) && Object.defineProperty(e, a, {
                  enumerable: !0,
                  get: t[a]
                });
              }
            }, r.o = function (e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }, r.r = function (e) {
              "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
              }), Object.defineProperty(e, "__esModule", {
                value: !0
              });
            };
            var n = {};
            return function () {
              "use strict";

              r.r(n), r.d(n, {
                default: function _default() {
                  return C;
                }
              });
              var e = r(98),
                  t = r.n(e),
                  a = r(697),
                  i = r.n(a);

              function o() {
                return o = Object.assign ? Object.assign.bind() : function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var a = arguments[t];

                    for (var r in a) {
                      Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
                    }
                  }

                  return e;
                }, o.apply(this, arguments);
              }

              var s = function s(e) {
                var a = e.pageClassName,
                    r = e.pageLinkClassName,
                    n = e.page,
                    i = e.selected,
                    s = e.activeClassName,
                    l = e.activeLinkClassName,
                    c = e.getEventListener,
                    u = e.pageSelectedHandler,
                    d = e.href,
                    p = e.extraAriaContext,
                    g = e.pageLabelBuilder,
                    m = e.rel,
                    f = e.ariaLabel || "Page " + n + (p ? " " + p : ""),
                    b = null;
                return i && (b = "page", f = e.ariaLabel || "Page " + n + " is your current page", a = void 0 !== a ? a + " " + s : s, void 0 !== r ? void 0 !== l && (r = r + " " + l) : r = l), t().createElement("li", {
                  className: a
                }, t().createElement("a", o({
                  rel: m,
                  role: d ? void 0 : "button",
                  className: r,
                  href: d,
                  tabIndex: i ? "-1" : "0",
                  "aria-label": f,
                  "aria-current": b,
                  onKeyPress: u
                }, c(u)), g(n)));
              };

              s.propTypes = {
                pageSelectedHandler: i().func.isRequired,
                selected: i().bool.isRequired,
                pageClassName: i().string,
                pageLinkClassName: i().string,
                activeClassName: i().string,
                activeLinkClassName: i().string,
                extraAriaContext: i().string,
                href: i().string,
                ariaLabel: i().string,
                page: i().number.isRequired,
                getEventListener: i().func.isRequired,
                pageLabelBuilder: i().func.isRequired,
                rel: i().string
              };
              var l = s;

              function c() {
                return c = Object.assign ? Object.assign.bind() : function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var a = arguments[t];

                    for (var r in a) {
                      Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
                    }
                  }

                  return e;
                }, c.apply(this, arguments);
              }

              var u = function u(e) {
                var a = e.breakLabel,
                    r = e.breakAriaLabel,
                    n = e.breakClassName,
                    i = e.breakLinkClassName,
                    o = e.breakHandler,
                    s = e.getEventListener,
                    l = n || "break";
                return t().createElement("li", {
                  className: l
                }, t().createElement("a", c({
                  className: i,
                  role: "button",
                  tabIndex: "0",
                  "aria-label": r,
                  onKeyPress: o
                }, s(o)), a));
              };

              u.propTypes = {
                breakLabel: i().oneOfType([i().string, i().node]),
                breakAriaLabel: i().string,
                breakClassName: i().string,
                breakLinkClassName: i().string,
                breakHandler: i().func.isRequired,
                getEventListener: i().func.isRequired
              };
              var d = u;

              function p(e) {
                return null != e ? e : arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
              }

              function g(e) {
                return g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                  return typeof e;
                } : function (e) {
                  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, g(e);
              }

              function m() {
                return m = Object.assign ? Object.assign.bind() : function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var a = arguments[t];

                    for (var r in a) {
                      Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
                    }
                  }

                  return e;
                }, m.apply(this, arguments);
              }

              function f(e, t) {
                return f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
                  return e.__proto__ = t, e;
                }, f(e, t);
              }

              function b(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }

              function v(e) {
                return v = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                }, v(e);
              }

              function y(e, t, a) {
                return t in e ? Object.defineProperty(e, t, {
                  value: a,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }) : e[t] = a, e;
              }

              var h = function (e) {
                !function (e, t) {
                  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                  e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                      value: e,
                      writable: !0,
                      configurable: !0
                    }
                  }), Object.defineProperty(e, "prototype", {
                    writable: !1
                  }), t && f(e, t);
                }(s, e);
                var a,
                    r,
                    n,
                    i,
                    o = (n = s, i = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;

                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                      t = v(n);

                  if (i) {
                    var a = v(this).constructor;
                    e = Reflect.construct(t, arguments, a);
                  } else e = t.apply(this, arguments);

                  return function (e, t) {
                    if (t && ("object" === g(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return b(e);
                  }(this, e);
                });

                function s(e) {
                  var a, r;
                  return function (e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                  }(this, s), y(b(a = o.call(this, e)), "handlePreviousPage", function (e) {
                    var t = a.state.selected;
                    a.handleClick(e, null, t > 0 ? t - 1 : void 0, {
                      isPrevious: !0
                    });
                  }), y(b(a), "handleNextPage", function (e) {
                    var t = a.state.selected,
                        r = a.props.pageCount;
                    a.handleClick(e, null, t < r - 1 ? t + 1 : void 0, {
                      isNext: !0
                    });
                  }), y(b(a), "handlePageSelected", function (e, t) {
                    if (a.state.selected === e) return a.callActiveCallback(e), void a.handleClick(t, null, void 0, {
                      isActive: !0
                    });
                    a.handleClick(t, null, e);
                  }), y(b(a), "handlePageChange", function (e) {
                    a.state.selected !== e && (a.setState({
                      selected: e
                    }), a.callCallback(e));
                  }), y(b(a), "getEventListener", function (e) {
                    return y({}, a.props.eventListener, e);
                  }), y(b(a), "handleClick", function (e, t, r) {
                    var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                        i = n.isPrevious,
                        o = void 0 !== i && i,
                        s = n.isNext,
                        l = void 0 !== s && s,
                        c = n.isBreak,
                        u = void 0 !== c && c,
                        d = n.isActive,
                        p = void 0 !== d && d;
                    e.preventDefault ? e.preventDefault() : e.returnValue = !1;
                    var g = a.state.selected,
                        m = a.props.onClick,
                        f = r;

                    if (m) {
                      var b = m({
                        index: t,
                        selected: g,
                        nextSelectedPage: r,
                        event: e,
                        isPrevious: o,
                        isNext: l,
                        isBreak: u,
                        isActive: p
                      });
                      if (!1 === b) return;
                      Number.isInteger(b) && (f = b);
                    }

                    void 0 !== f && a.handlePageChange(f);
                  }), y(b(a), "handleBreakClick", function (e, t) {
                    var r = a.state.selected;
                    a.handleClick(t, e, r < e ? a.getForwardJump() : a.getBackwardJump(), {
                      isBreak: !0
                    });
                  }), y(b(a), "callCallback", function (e) {
                    void 0 !== a.props.onPageChange && "function" == typeof a.props.onPageChange && a.props.onPageChange({
                      selected: e
                    });
                  }), y(b(a), "callActiveCallback", function (e) {
                    void 0 !== a.props.onPageActive && "function" == typeof a.props.onPageActive && a.props.onPageActive({
                      selected: e
                    });
                  }), y(b(a), "getElementPageRel", function (e) {
                    var t = a.state.selected,
                        r = a.props,
                        n = r.nextPageRel,
                        i = r.prevPageRel,
                        o = r.selectedPageRel;
                    return t - 1 === e ? i : t === e ? o : t + 1 === e ? n : void 0;
                  }), y(b(a), "pagination", function () {
                    var e = [],
                        r = a.props,
                        n = r.pageRangeDisplayed,
                        i = r.pageCount,
                        o = r.marginPagesDisplayed,
                        s = r.breakLabel,
                        l = r.breakClassName,
                        c = r.breakLinkClassName,
                        u = r.breakAriaLabels,
                        p = a.state.selected;
                    if (i <= n) for (var g = 0; g < i; g++) {
                      e.push(a.getPageElement(g));
                    } else {
                      var m = n / 2,
                          f = n - m;
                      p > i - n / 2 ? m = n - (f = i - p) : p < n / 2 && (f = n - (m = p));

                      var b,
                          v,
                          y = function y(e) {
                        return a.getPageElement(e);
                      },
                          h = [];

                      for (b = 0; b < i; b++) {
                        var C = b + 1;
                        if (C <= o) h.push({
                          type: "page",
                          index: b,
                          display: y(b)
                        });else if (C > i - o) h.push({
                          type: "page",
                          index: b,
                          display: y(b)
                        });else if (b >= p - m && b <= p + (0 === p && n > 1 ? f - 1 : f)) h.push({
                          type: "page",
                          index: b,
                          display: y(b)
                        });else if (s && h.length > 0 && h[h.length - 1].display !== v && (n > 0 || o > 0)) {
                          var L = b < p ? u.backward : u.forward;
                          v = t().createElement(d, {
                            key: b,
                            breakAriaLabel: L,
                            breakLabel: s,
                            breakClassName: l,
                            breakLinkClassName: c,
                            breakHandler: a.handleBreakClick.bind(null, b),
                            getEventListener: a.getEventListener
                          }), h.push({
                            type: "break",
                            index: b,
                            display: v
                          });
                        }
                      }

                      h.forEach(function (t, a) {
                        var r = t;
                        "break" === t.type && h[a - 1] && "page" === h[a - 1].type && h[a + 1] && "page" === h[a + 1].type && h[a + 1].index - h[a - 1].index <= 2 && (r = {
                          type: "page",
                          index: t.index,
                          display: y(t.index)
                        }), e.push(r.display);
                      });
                    }
                    return e;
                  }), void 0 !== e.initialPage && void 0 !== e.forcePage && console.warn("(react-paginate): Both initialPage (".concat(e.initialPage, ") and forcePage (").concat(e.forcePage, ") props are provided, which is discouraged.") + " Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"), r = e.initialPage ? e.initialPage : e.forcePage ? e.forcePage : 0, a.state = {
                    selected: r
                  }, a;
                }

                return a = s, (r = [{
                  key: "componentDidMount",
                  value: function value() {
                    var e = this.props,
                        t = e.initialPage,
                        a = e.disableInitialCallback,
                        r = e.extraAriaContext,
                        n = e.pageCount,
                        i = e.forcePage;
                    void 0 === t || a || this.callCallback(t), r && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(n) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(n, "). Did you forget a Math.ceil()?")), void 0 !== t && t > n - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(t, " > ").concat(n - 1, ").")), void 0 !== i && i > n - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(i, " > ").concat(n - 1, ")."));
                  }
                }, {
                  key: "componentDidUpdate",
                  value: function value(e) {
                    void 0 !== this.props.forcePage && this.props.forcePage !== e.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({
                      selected: this.props.forcePage
                    })), Number.isInteger(e.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
                  }
                }, {
                  key: "getForwardJump",
                  value: function value() {
                    var e = this.state.selected,
                        t = this.props,
                        a = t.pageCount,
                        r = e + t.pageRangeDisplayed;
                    return r >= a ? a - 1 : r;
                  }
                }, {
                  key: "getBackwardJump",
                  value: function value() {
                    var e = this.state.selected - this.props.pageRangeDisplayed;
                    return e < 0 ? 0 : e;
                  }
                }, {
                  key: "getElementHref",
                  value: function value(e) {
                    var t = this.props,
                        a = t.hrefBuilder,
                        r = t.pageCount,
                        n = t.hrefAllControls;
                    if (a) return n || e >= 0 && e < r ? a(e + 1, r, this.state.selected) : void 0;
                  }
                }, {
                  key: "ariaLabelBuilder",
                  value: function value(e) {
                    var t = e === this.state.selected;

                    if (this.props.ariaLabelBuilder && e >= 0 && e < this.props.pageCount) {
                      var a = this.props.ariaLabelBuilder(e + 1, t);
                      return this.props.extraAriaContext && !t && (a = a + " " + this.props.extraAriaContext), a;
                    }
                  }
                }, {
                  key: "getPageElement",
                  value: function value(e) {
                    var a = this.state.selected,
                        r = this.props,
                        n = r.pageClassName,
                        i = r.pageLinkClassName,
                        o = r.activeClassName,
                        s = r.activeLinkClassName,
                        c = r.extraAriaContext,
                        u = r.pageLabelBuilder;
                    return t().createElement(l, {
                      key: e,
                      pageSelectedHandler: this.handlePageSelected.bind(null, e),
                      selected: a === e,
                      rel: this.getElementPageRel(e),
                      pageClassName: n,
                      pageLinkClassName: i,
                      activeClassName: o,
                      activeLinkClassName: s,
                      extraAriaContext: c,
                      href: this.getElementHref(e),
                      ariaLabel: this.ariaLabelBuilder(e),
                      page: e + 1,
                      pageLabelBuilder: u,
                      getEventListener: this.getEventListener
                    });
                  }
                }, {
                  key: "render",
                  value: function value() {
                    var e = this.props.renderOnZeroPageCount;
                    if (0 === this.props.pageCount && void 0 !== e) return e ? e(this.props) : e;
                    var a = this.props,
                        r = a.disabledClassName,
                        n = a.disabledLinkClassName,
                        i = a.pageCount,
                        o = a.className,
                        s = a.containerClassName,
                        l = a.previousLabel,
                        c = a.previousClassName,
                        u = a.previousLinkClassName,
                        d = a.previousAriaLabel,
                        g = a.prevRel,
                        f = a.nextLabel,
                        b = a.nextClassName,
                        v = a.nextLinkClassName,
                        y = a.nextAriaLabel,
                        h = a.nextRel,
                        C = this.state.selected,
                        L = 0 === C,
                        P = C === i - 1,
                        k = "".concat(p(c)).concat(L ? " ".concat(p(r)) : ""),
                        x = "".concat(p(b)).concat(P ? " ".concat(p(r)) : ""),
                        N = "".concat(p(u)).concat(L ? " ".concat(p(n)) : ""),
                        E = "".concat(p(v)).concat(P ? " ".concat(p(n)) : ""),
                        T = L ? "true" : "false",
                        O = P ? "true" : "false";
                    return t().createElement("ul", {
                      className: o || s,
                      role: "navigation",
                      "aria-label": "Pagination"
                    }, t().createElement("li", {
                      className: k
                    }, t().createElement("a", m({
                      className: N,
                      href: this.getElementHref(C - 1),
                      tabIndex: L ? "-1" : "0",
                      role: "button",
                      onKeyPress: this.handlePreviousPage,
                      "aria-disabled": T,
                      "aria-label": d,
                      rel: g
                    }, this.getEventListener(this.handlePreviousPage)), l)), this.pagination(), t().createElement("li", {
                      className: x
                    }, t().createElement("a", m({
                      className: E,
                      href: this.getElementHref(C + 1),
                      tabIndex: P ? "-1" : "0",
                      role: "button",
                      onKeyPress: this.handleNextPage,
                      "aria-disabled": O,
                      "aria-label": y,
                      rel: h
                    }, this.getEventListener(this.handleNextPage)), f)));
                  }
                }]) && function (e, t) {
                  for (var a = 0; a < t.length; a++) {
                    var r = t[a];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                  }
                }(a.prototype, r), Object.defineProperty(a, "prototype", {
                  writable: !1
                }), s;
              }(e.Component);

              y(h, "propTypes", {
                pageCount: i().number.isRequired,
                pageRangeDisplayed: i().number,
                marginPagesDisplayed: i().number,
                previousLabel: i().node,
                previousAriaLabel: i().string,
                prevPageRel: i().string,
                prevRel: i().string,
                nextLabel: i().node,
                nextAriaLabel: i().string,
                nextPageRel: i().string,
                nextRel: i().string,
                breakLabel: i().oneOfType([i().string, i().node]),
                breakAriaLabels: i().shape({
                  forward: i().string,
                  backward: i().string
                }),
                hrefBuilder: i().func,
                hrefAllControls: i().bool,
                onPageChange: i().func,
                onPageActive: i().func,
                onClick: i().func,
                initialPage: i().number,
                forcePage: i().number,
                disableInitialCallback: i().bool,
                containerClassName: i().string,
                className: i().string,
                pageClassName: i().string,
                pageLinkClassName: i().string,
                pageLabelBuilder: i().func,
                activeClassName: i().string,
                activeLinkClassName: i().string,
                previousClassName: i().string,
                nextClassName: i().string,
                previousLinkClassName: i().string,
                nextLinkClassName: i().string,
                disabledClassName: i().string,
                disabledLinkClassName: i().string,
                breakClassName: i().string,
                breakLinkClassName: i().string,
                extraAriaContext: i().string,
                ariaLabelBuilder: i().func,
                eventListener: i().string,
                renderOnZeroPageCount: i().func,
                selectedPageRel: i().string
              }), y(h, "defaultProps", {
                pageRangeDisplayed: 2,
                marginPagesDisplayed: 3,
                activeClassName: "selected",
                previousLabel: "Previous",
                previousClassName: "previous",
                previousAriaLabel: "Previous page",
                prevPageRel: "prev",
                prevRel: "prev",
                nextLabel: "Next",
                nextClassName: "next",
                nextAriaLabel: "Next page",
                nextPageRel: "next",
                nextRel: "next",
                breakLabel: "...",
                breakAriaLabels: {
                  forward: "Jump forward",
                  backward: "Jump backward"
                },
                disabledClassName: "disabled",
                disableInitialCallback: !1,
                pageLabelBuilder: function pageLabelBuilder(e) {
                  return e;
                },
                eventListener: "onClick",
                renderOnZeroPageCount: void 0,
                selectedPageRel: "canonical",
                hrefAllControls: !1
              });
              var C = h;
            }(), n;
          }();
        }, e.exports = r(a(689));
      },
      580: function _(e) {
        "use strict";

        e.exports = require("prop-types");
      },
      689: function _(e) {
        "use strict";

        e.exports = require("react");
      },
      978: function _(t) {
        "use strict";

        if (void 0 === e) {
          var a = new Error("Cannot find module 'gatsby'");
          throw a.code = "MODULE_NOT_FOUND", a;
        }

        t.exports = e;
      },
      426: function _(e) {
        "use strict";

        if (void 0 === t) {
          var a = new Error("Cannot find module 'gatsby-plugin-image'");
          throw a.code = "MODULE_NOT_FOUND", a;
        }

        e.exports = t;
      },
      985: function _(e, t, a) {
        var r = a(261),
            n = a(111),
            i = _defineProperty({}, r.GATSBY, ["GatsbyImage", "getImage"]);

        var o = {};
        Object.values(r).forEach(function (e) {
          var t;

          try {
            switch (e) {
              case r.GATSBY:
                t = a(426);
                break;

              case r.NEXTJS:
              default:
                t = null;
            }
          } catch (t) {
            return console.log("won't resolve Image requirement for '".concat(e, "'")), !0;
          }

          if (t) return o = n(t, i[e], e), e === r.GATSBY && (o.Image = o.GatsbyImage), !1;
        }), e.exports = o;
      },
      825: function _(e, t, a) {
        var r = a(261),
            n = a(111),
            i = _defineProperty({}, r.GATSBY, ["Link"]);

        var o = {};
        Object.values(r).forEach(function (e) {
          var t;

          try {
            switch (e) {
              case r.GATSBY:
                t = a(978);
                break;

              case r.NEXTJS:
              default:
                t = null;
            }
          } catch (t) {
            return console.log("won't resolve Link requirement for '".concat(e, "'")), !0;
          }

          if (t) return o = n(t, i[e], e), !1;
        }), e.exports = o;
      },
      111: function _(e) {
        e.exports = function (e, t, a) {
          var r = {};
          return e ? ("default" === t ? r = _objectSpread({}, e.default) : t.forEach(function (t) {
            r[t] = e[t];
          }), r._which = a, r.default = r, r.__esModule = !0, r) : r;
        };
      },
      261: function _(e) {
        "use strict";

        e.exports = JSON.parse('{"GATSBY":"gatsby","NEXTJS":"nextjs"}');
      }
    },
        r = {};

    function n(e) {
      var t = r[e];
      if (void 0 !== t) return t.exports;
      var i = r[e] = {
        id: e,
        exports: {}
      };
      return a[e].call(i.exports, i, i.exports, n), i.exports;
    }

    n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, {
        a: t
      }), t;
    }, n.d = function (e, t) {
      for (var a in t) {
        n.o(t, a) && !n.o(e, a) && Object.defineProperty(e, a, {
          enumerable: !0,
          get: t[a]
        });
      }
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.nc = void 0;
    var i = {};
    return function () {
      "use strict";

      n.r(i), n.d(i, {
        containerId: function containerId() {
          return p;
        },
        default: function _default() {
          return d;
        }
      });

      var e = n(689),
          t = n.n(e),
          a = n(580),
          r = n.n(a),
          o = n(427),
          s = n(352),
          l = n(521),
          c = n(779),
          u = function u(e) {
        return t().createElement("div", {
          className: "".concat(c.xv),
          "data-test": l.I.GRID_POST_CONTAINER,
          id: e.containerId
        }, "number" === e.type && e.queryArgs.total_found > e.gridLimit ? t().createElement(o.default, e) : t().createElement(s.default, e));
      };

      u.propTypes = {
        type: r().string,
        queryArgs: r().shape({
          total_found: r().number,
          Post: r().array
        }).isRequired,
        gridLimit: r().number,
        handlePageChange: r().func,
        containerId: r().string
      }, u.defaultProps = {
        type: "number",
        gridLimit: 12,
        handlePageChange: function handlePageChange(e) {
          var t = e.selected;
          return console.log(t);
        },
        containerId: l.defaultAttributes.containerId
      };
      var d = u;
      var p = l.defaultAttributes.containerId;
    }(), i;
  }();
});